import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const carousel = document.querySelector('.related-posts__carousel');

  if (carousel) {
    new Swiper(carousel, {
      slidesPerView: 1,
      spaceBetween: 40,
      centerInsufficientSlides: true,

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 80,
        },
      },
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }
});
